var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimed(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "0 0 212 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2230_17684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.054 168.691C181.721 152.986 192.125 130.708 192.125 106C192.125 58.4345 153.566 19.875 106 19.875C58.4345 19.875 19.875 58.4345 19.875 106C19.875 130.708 30.2794 152.986 46.9459 168.691C62.3644 183.22 83.1423 192.125 106 192.125C128.858 192.125 149.636 183.22 165.054 168.691Z",
    fill: "#E9F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.448 16H115.809V83.1548H141.448V16Z",
    fill: "#00326F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.448 16H115.809V83.1548H141.448V16Z",
    fill: "url(#paint0_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1407 61.4404H53.3809V173.425H96.1407V61.4404Z",
    fill: "#00326F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.274 39.127H102.996V173.425H154.274V39.127Z",
    fill: "#00326F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1407 61.4404H53.3809V173.425H96.1407V61.4404Z",
    fill: "url(#paint1_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.274 39.127H102.996V173.425H154.274V39.127Z",
    fill: "url(#paint2_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M154.262 39.127L109.11 42.7042V173.784H102.996V39.127H154.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M96.151 61.4404L58.4759 64.4315V173.784H53.3672V61.4404H96.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M69.1971 73.6309H65.9668V173.436H69.1971V73.6309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M79.1151 73.6309H75.8848V173.436H79.1151V73.6309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M89.0213 73.6309H85.791V173.436H89.0213V73.6309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M121.156 49.5713H117.926V173.424H121.156V49.5713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M131.074 49.5713H127.844V173.424H131.074V49.5713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M140.98 49.5713H137.75V173.424H140.98V49.5713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4856 182.515C88.6584 189.583 83.0682 195.454 75.9996 195.626C68.931 195.799 63.0607 190.209 62.888 183.14C62.7152 176.072 68.3054 170.201 75.374 170.029C82.4426 169.856 88.3129 175.446 88.4856 182.515Z",
    fill: "url(#paint3_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4269 180.507C72.6752 190.668 64.6393 199.107 54.4782 199.355C44.3171 199.603 35.8786 191.567 35.6303 181.406C35.382 171.245 43.4179 162.807 53.579 162.558C63.7401 162.31 72.1786 170.346 72.4269 180.507Z",
    fill: "url(#paint4_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5473 186.087C40.6877 191.83 36.1457 196.6 30.4024 196.74C24.6592 196.88 19.8896 192.338 19.7493 186.595C19.6089 180.852 24.1509 176.082 29.8942 175.942C35.6374 175.802 40.407 180.344 40.5473 186.087Z",
    fill: "url(#paint5_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.579 47.8253C202.752 54.8939 197.162 60.7641 190.093 60.9369C183.025 61.1096 177.154 55.5194 176.982 48.4508C176.809 41.3822 182.399 35.512 189.468 35.3392C196.536 35.1665 202.407 40.7567 202.579 47.8253Z",
    fill: "url(#paint6_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.521 45.8176C186.769 55.9787 178.733 64.4172 168.572 64.6655C158.411 64.9138 149.972 56.8779 149.724 46.7168C149.476 36.5557 157.512 28.1172 167.673 27.8689C177.834 27.6206 186.272 35.6565 186.521 45.8176Z",
    fill: "url(#paint7_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.641 51.3974C154.781 57.1406 150.239 61.9102 144.496 62.0506C138.753 62.1909 133.983 57.6489 133.843 51.9057C133.703 46.1624 138.245 41.3929 143.988 41.2525C149.731 41.1121 154.501 45.6542 154.641 51.3974Z",
    fill: "url(#paint8_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.7489,
    cy: 50.4642,
    r: 10.4021,
    transform: "rotate(-1.39991 18.7489 50.4642)",
    fill: "url(#paint9_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.953 178.077C197.272 191.14 186.941 201.989 173.878 202.308C160.815 202.627 149.966 192.296 149.647 179.233C149.328 166.17 159.659 155.321 172.722 155.002C185.785 154.683 196.634 165.014 196.953 178.077Z",
    fill: "url(#paint10_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.277 174.366C167.736 193.144 152.885 208.739 134.107 209.198C115.328 209.657 99.7333 194.806 99.2744 176.028C98.8155 157.25 113.666 141.655 132.445 141.196C151.223 140.737 166.818 155.588 167.277 174.366Z",
    fill: "url(#paint11_linear_2230_17684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.362 184.68C108.621 195.294 100.227 204.108 89.6135 204.368C78.9996 204.627 70.1852 196.233 69.9258 185.619C69.6664 175.006 78.0603 166.191 88.6742 165.932C99.288 165.672 108.103 174.066 108.362 184.68Z",
    fill: "url(#paint12_linear_2230_17684)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2230_17684",
    x1: 128.168,
    y1: 74.409,
    x2: 130.333,
    y2: -43.0431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2230_17684",
    x1: 79.1995,
    y1: 246.873,
    x2: 66.2304,
    y2: -131.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2230_17684",
    x1: 133.385,
    y1: 245.018,
    x2: 120.416,
    y2: -133.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2230_17684",
    x1: 55.7562,
    y1: 197.964,
    x2: 42.8249,
    y2: 166.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2230_17684",
    x1: 55.7562,
    y1: 197.964,
    x2: 42.8249,
    y2: 166.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2230_17684",
    x1: 55.7562,
    y1: 197.964,
    x2: 42.8249,
    y2: 166.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2230_17684",
    x1: 169.85,
    y1: 63.275,
    x2: 156.919,
    y2: 32.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2230_17684",
    x1: 169.85,
    y1: 63.275,
    x2: 156.919,
    y2: 32.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2230_17684",
    x1: 169.85,
    y1: 63.275,
    x2: 156.919,
    y2: 32.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2230_17684",
    x1: 19.2447,
    y1: 60.0773,
    x2: 9.274,
    y2: 47.2848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2230_17684",
    x1: 136.468,
    y1: 206.629,
    x2: 112.57,
    y2: 149.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2230_17684",
    x1: 136.468,
    y1: 206.629,
    x2: 112.57,
    y2: 149.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2230_17684",
    x1: 136.468,
    y1: 206.629,
    x2: 112.57,
    y2: 149.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2230_17684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 212,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimed);
export default __webpack_public_path__ + "static/media/claimed.bb630903.svg";
export { ForwardRef as ReactComponent };